import { Component, Input, OnInit } from '@angular/core';
import { FichaMedicaService } from 'src/app/services/ficha-medica.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-documentos-previos',
  templateUrl: './documentos-previos.component.html',
  styleUrls: ['./documentos-previos.component.css']
})
export class DocumentosPreviosComponent implements OnInit {
  @Input() consulta: any = {};

  documentos_paciente: any[] = [];
  documentosFiltradosUI: any[] = [];

  // opciones dinámicas
  tiposDocumento: string[] = [];   // ['Diagnostico','Receta','Certificado','Examen','Otros']
  autores: string[] = [];          // nombres de médico únicos

 filtros = {
  origenGeneradoTratante: false,
  origenSubidoTratante: false,
  origenSubidoPaciente: false,
  fechaDesde: '',
  fechaHasta: '',
  tipos: [] as string[],   // tipos seleccionados
  nombre: ''
};
  isLoading: boolean = true;

  
  mostrarFiltros = false;

  constructor(
    private fichaMedicaService: FichaMedicaService,
    private _functions: FunctionsService,
    public _generalServices: GeneralService
  ) {}

  ngOnInit(): void {
    this.getFichaPaciente();
  }

  getFichaPaciente() {
      this.isLoading = true;

    this.fichaMedicaService.getFichaPaciente({
      paciente: this.consulta.rut_paciente,
      doc_id: null,
      date: null
    })
    .then((result: any) => {
      this.documentos_paciente = result.documentos || [];
      // console.log(this.documentos_paciente);

      // construir listas de filtros
      const tipos = new Set<string>();
      const autores = new Set<string>();

      this.documentos_paciente.forEach(d => {
        tipos.add(d.tipo_doc || 'Otros');
        if (d?.nombreMedico) autores.add(String(d.nombreMedico).trim());
      });

      this.tiposDocumento = Array.from(tipos).sort();
      this.autores = Array.from(autores).sort();

      // primera carga (sin filtros)
this.documentosFiltradosUI = this.ordenarPorFechaDesc([
  ...this.documentos_paciente
]);
      this.isLoading = false;
    })
    .catch(error => console.error(error));

  }

  /** En tu template el (change) del input date llama a este método */
  onChangeFechaPreset() {
    this.filterDocs();
  }

  filterDocs() {
  let arr = [...this.documentos_paciente];

  // ---- Origen del documento (checkbox múltiples) ----
  if (this.filtros.origenGeneradoTratante ||
      this.filtros.origenSubidoTratante ||
      this.filtros.origenSubidoPaciente) {

    arr = arr.filter(d => {
      const origen = this.getOrigenDoc(d); // 'GENERADO_TRATANTE' | 'SUBIDO_TRATANTE' | 'SUBIDO_PACIENTE' | null
      if (origen === 'GENERADO_CONSULTAS' && this.filtros.origenGeneradoTratante) return true;
      if (origen === 'SUBIDO_TRATANTE'   && this.filtros.origenSubidoTratante)   return true;
      if (origen === 'SUBIDO_PACIENTE'   && this.filtros.origenSubidoPaciente)   return true;
      return false;
    });
  }

  // ---- Rango de fechas ----
  const desde = this.filtros.fechaDesde || null;
  const hasta = this.filtros.fechaHasta || null;

  if (desde || hasta) {
    arr = arr.filter(d => {
      const ymd = this.getDocYMD(d);
      if (!ymd) return false;
      if (desde && ymd < desde) return false;
      if (hasta && ymd > hasta) return false;
      return true;
    });
  }

  // ---- Tipo de documento (checklist) ----
  if (this.filtros.tipos.length) {
    arr = arr.filter(d => this.filtros.tipos.includes(d.tipo_doc || 'Otros'));
  }

  // ---- Buscar por nombre ----
 // ---- Buscar por nombre ----
// ---- Buscar por nombre ----
if (this.filtros.nombre?.trim()) {
  const q = this.filtros.nombre.trim().toLowerCase();
  arr = arr.filter(d => {
    const nombre = this.getDocNombreMostrar(d).toLowerCase();
    return nombre.includes(q);
  });
}



this.documentosFiltradosUI = this.ordenarPorFechaDesc(arr);
}


  // ===== Helpers UI =====

  getOrigen(doc: any): string {
    // Ajusta si tienes otra lógica para el origen
    return doc?.tel_doc_app_boo_id ? 'Teleconsulta' : 'Documentos';
  }

  descargarDoc(doc: any) {
this._generalServices.descargarFileAtt(doc.att_id, this.getFileName(doc), null, null, doc.att_use_id, doc.tel_doc_app_boo_id, doc.tipo_doc);  }

  verDoc(doc: any) {
    const url = doc.att_path || '';
    if (url) { window.open(url, '_blank'); }
  }

  formatFecha(value: string): string {
    const d = this.parseFecha(value);
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
  }

  // ===== Helpers internos =====

  /** Devuelve 'YYYY-MM-DD' desde att_date_doc (ISO) o desde att_date si no existe */
  private getDocYMD(doc: any): string | null {
    if (doc?.att_date_doc) {
      // att_date_doc viene como '2025-10-13T13:28:05' -> tomamos solo la fecha
      const iso = String(doc.att_date_doc);
      if (iso.length >= 10) return iso.substr(0, 10);
    }
    if (doc?.att_date) {
      // fallback al viejo campo
      const d = this.parseFecha(doc.att_date);
      return this.toYMD(d);
    }
    return null;
  }

  private getFileName(doc: any): string {
  // Para documentos generados en consulta, usar el nombre calculado
  if (doc.upload_by == 1) {
    return this.getDocNombreMostrar(doc) + '.pdf';
  }

  // Si el backend manda un nombre de descarga explícito
  if (doc.file_name_desc) return doc.file_name_desc;

  // Si es subido por tratante/paciente y quieres usar el nombre limpio:
  if ((doc.upload_by == 2 || doc.upload_by == 3) && doc.att_name) {
    return this.getDocNombreMostrar(doc);
  }

  // Fallback: nombre físico de att_path
  if (doc.att_path) {
    return (doc.att_path as string).split('/').pop() || `documento_${doc.att_id}.pdf`;
  }

  return `documento_${doc.att_id}.pdf`;
}


  /** Parser robusto para '10/13/2025' o '13/10/2025', y otros formatos comunes */
  private parseFecha(str: string): Date {
    if (!str) return new Date(0);
    const direct = Date.parse(str as any);
    if (!isNaN(direct)) return new Date(direct);

    const parts = (str || '').split('/');
    if (parts.length === 3) {
      const p1 = parseInt(parts[0], 10);
      const p2 = parseInt(parts[1], 10);
      const y  = parseInt(parts[2], 10);
      const dd = (p1 > 12 || (p2 <= 12 && p1 <= 12)) ? p1 : p2;
      const mm = (p1 > 12 || (p2 <= 12 && p1 <= 12)) ? p2 : p1;
      return new Date(y, mm - 1, dd);
    }
    return new Date(str);
  }

  private toYMD(d: Date): string {
    const p = (n: number) => (n < 10 ? '0' + n : '' + n);
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  }
  isTipoSelected(tipo: string): boolean {
  return this.filtros.tipos.includes(tipo);
}

toggleTipo(tipo: string, checked: boolean) {
  if (checked) {
    if (!this.filtros.tipos.includes(tipo)) {
      this.filtros.tipos.push(tipo);
    }
  } else {
    this.filtros.tipos = this.filtros.tipos.filter(t => t !== tipo);
  }
  this.filterDocs();
}
private getOrigenDoc(doc: any): string | null {
  // TODO: ajusta esta lógica según los flags reales que tengas en cada doc.
  // Ejemplos de cómo podrías mapear:
  if (doc.upload_by == 1 ) return 'GENERADO_CONSULTAS';
  if (doc.upload_by == 2)   return 'SUBIDO_TRATANTE';
  if (doc.upload_by == 3)   return 'SUBIDO_PACIENTE';

  // Si no tienes flags aún, puedes dejar null y más adelante afinar.
  return null;
}

limpiarFiltros(): void {
  this.filtros = {
    origenGeneradoTratante: false,
    origenSubidoTratante: false,
    origenSubidoPaciente: false,
    fechaDesde: '',
    fechaHasta: '',
    tipos: [],
    nombre: ''
  };
  this.documentosFiltradosUI = [...this.documentos_paciente];
  this.mostrarFiltros = false;
}


public getDocNombreMostrar(doc: any): string {

  // ===== 1) Documentos generados en consulta (upload_by == 1) =====
  if (doc.upload_by == 1) {
    return this.getNombreGeneradoConsulta(doc);
  }

  // ===== 2) Subidos por tratante o paciente (2 y 3): limpiar att_name =====
  if ((doc.upload_by == 2 || doc.upload_by == 3) && doc.att_name) {
    let name = String(doc.att_name);

    // quitar prefijo "230-T9xJ403919qhMON37UfF-..."
    const parts = name.split('-');
    if (parts.length >= 3) {
      name = parts.slice(2).join('-'); // "RECETA PRUEBA.pdf.jpg"
    }

    // quitar la ÚLTIMA extensión si es de imagen (jpg, png, etc.)
    const lastDot = name.lastIndexOf('.');
    if (lastDot > 0) {
      const ext = name.slice(lastDot + 1).toLowerCase();
      const extImg = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

      if (extImg.includes(ext)) {
        name = name.slice(0, lastDot); // "RECETA PRUEBA.pdf"
      }
    }

    return name;
  }

  // ===== 3) Otros casos: usar nombre "bonito" si viene del backend =====
  if (doc.nombreArchivo) return String(doc.nombreArchivo);
  if (doc.file_name)     return String(doc.file_name);
  if (doc.att_name)      return String(doc.att_name);

  return `DOC_${doc.att_id}`;
}

/** Nombre para documentos GENERADOS EN CONSULTA (upload_by == 1) */
private getNombreGeneradoConsulta(doc: any): string {
  // Prefijo desde el tipo de documento: "Certificado" -> "CERTIFICADO"
  const tipo = (doc.tipo_doc || 'Documento')
    .toString()
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '_'); // por si hay espacios

  // Folio de la consulta: tel_doc_app_boo_id -> "03206"
  const consultaId = doc.tel_doc_app_boo_id || 0;
  const consultaStr = String(consultaId).padStart(5, '0');

  // Tomar todos los docs de la misma consulta y mismo tipo
  const grupo = this.documentos_paciente.filter(d =>
    d.upload_by == 1 &&
    d.tipo_doc === doc.tipo_doc &&
    d.tel_doc_app_boo_id === doc.tel_doc_app_boo_id
  );

  // Ordenar por att_date_doc (o att_date como respaldo)
  const ordenados = [...grupo].sort((a, b) => {
    const da = new Date(a.att_date_doc || a.att_date || 0).getTime();
    const db = new Date(b.att_date_doc || b.att_date || 0).getTime();
    return da - db;
  });

  // Posición de este doc en el grupo (correlativo)
  const idx = ordenados.findIndex(d => d.att_id === doc.att_id);
  const correlativo = (idx >= 0 ? idx + 1 : 1).toString().padStart(2, '0');

  // Resultado: p.ej. CERTIFICADO_01_03206
  return `${tipo}_${correlativo}_${consultaStr}`;
}

cerrarFiltros(): void {
  this.mostrarFiltros = false;
}

aplicarFiltros(): void {
  this.filterDocs();
  this.mostrarFiltros = false;
}

hasFiltrosActivos(): boolean {
  const f = this.filtros;

  // checkboxes origen
  if (f.origenGeneradoTratante || f.origenSubidoTratante || f.origenSubidoPaciente) return true;

  // fechas
  if ((f.fechaDesde && f.fechaDesde.trim()) || (f.fechaHasta && f.fechaHasta.trim())) return true;

  // tipos
  if (Array.isArray(f.tipos) && f.tipos.length > 0) return true;

  // nombre
  if (f.nombre && f.nombre.trim()) return true;

  return false;
}

private ordenarPorFechaDesc(arr: any[]): any[] {
  return arr.sort((a, b) => {
    const fa = new Date(a.att_date_doc || a.att_date || 0).getTime();
    const fb = new Date(b.att_date_doc || b.att_date || 0).getTime();
    return fb - fa; // DESC: más reciente primero
  });
}

}
